import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createStore } from './create-store';

const DEFAULT_DATE_RANGE = [dayjs().subtract(1, 'months'), dayjs()];

export enum EOverdueType {
  unloading = 'unloading',
  loading = 'loading',
}

export interface IOverdueFilter {
  date?: Dayjs[];
  transportLine?: string;
  type: EOverdueType;
}

type TState = {
  filters: IOverdueFilter;
};

type TActions = {
  setFilters: (value: IOverdueFilter | undefined) => void;
};

export const useOverdueFiltersStore = createStore<TState & TActions>(
  (set) => ({
    filters: { date: DEFAULT_DATE_RANGE, type: EOverdueType.unloading },
    setFilters: (filters: IOverdueFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'overdue-filters-store',
);
